<h4 class="text-center">{{ 'MESSAGES.SUGGESTIONS.LOGIN_TO_SSO_ACCOUNT' | translate: {portalId} }}</h4>

<form [formRoot]="form" class="app-form mt-6">
  <div class="form-group">
    <label class="col-form-label">{{ 'LABELS.EMAIL_ADDRESS' | translate }}</label>
    <input
      class="form-control"
      [formField]="form.email"
      placeholder="{{ 'MESSAGES.PROMPTS.ENTER_EMAIL_ADDRESS' | translate }}"
      type="email"
      id="emailInput"
      autocomplete="email"
      inputmode="email"
      appFormFieldOnError
      [customMessages]="{ pattern: 'Email address not recognized. Try again or login below.' }"
    />
  </div>

  @if (errorMessage()) {
  <app-alert class="mt-4!" type="danger" id="emailErrorMessage">{{ errorMessage() }}</app-alert>
  } @if (successMessage()) {
  <app-alert class="mt-4!" type="success" id="emailSuccessMessage">{{ successMessage() }}</app-alert>
  }

  <div class="form-group mt-4">
    <button
      class="btn btn-gradient btn-block p-2"
      [disabled]="form().invalid() || form().submitting()"
      id="emailLoginButton"
    >
      @if (form().submitting()) {
      <span
        class="inline-block size-4 mr-2 align-[-0.125em] rounded-[50%] border-[0.2em] border-solid border-current border-r-transparent animate-spinner-border motion-reduce:[animation-duration:1.5s]"
        role="status"
        aria-hidden="true"
      ></span>
      } {{ 'LABELS.LOGIN' | translate }}
    </button>
  </div>
</form>

@if (isAllowedToCreateAccount) {
<div class="flex items-center justify-center mb-2">
  <hr class="grow m-0" />
  <span class="text-[12px]! whitespace-nowrap px-4">{{'LABELS.OR' | translate}}</span>
  <hr class="grow m-0" />
</div>

<div class="mt-0 mb-0">
  @for (item of providers; track $index) {
  <button
    type="button"
    class="btn btn-outline-dark btn-block p-2 mb-2"
    [disabled]="!item.enabled"
    (click)="login(item.provider)"
    id="{{ item.provider }}LoginButton"
  >
    <app-feather-icons icon="{{ item.icon }}" stroke="none" width="24" height="24" class="mr-2"></app-feather-icons>
    Login with {{ item.provider | titlecase }}
  </button>
  }
</div>
}
